// URL pública y canónica del sitio (sin slash final). Debe coincidir con next-sitemap.config.js.
export const SITE_URL = process.env.NEXT_PUBLIC_CURRENT_HOST || 'https://evanhub.com';
